// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* our variables */\n#configUploads[data-v-63155678] {\n  position: fixed;\n  z-index: 1000;\n  background: #fff;\n  color: black;\n  border: 1px solid #a8a8a8;\n  box-shadow: 2px 2px 7px #a8a8a8;\n  right: 5px;\n  bottom: 5px;\n  padding: 0.5em 1em;\n}\n#configUploads > div[data-v-63155678] {\n  padding: 0.25em 0;\n}\n#configUploads > div[data-v-63155678]:not(:last-child) {\n  border-bottom: 1px solid #b1b1b1;\n}", ""]);
// Exports
module.exports = exports;
